import {
  rating_styles_default
} from "./chunk.72LIRKWQ.js";
import {
  form_control_styles_default
} from "./chunk.EK4QQDDG.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/rating/rating.styles.ts
var rating_styles_default2 = r` ${rating_styles_default} ${component_mobile_styles_default} ${form_control_styles_default} `;

export {
  rating_styles_default2 as rating_styles_default
};
